import {ScreenOrientation} from '@gongxigames/framework/core';
import {ScrollToFullscreen} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/ScrollToFullscreen';

export class ScrollForSpecificIOS15 extends ScrollToFullscreen {
    public static matchVersion(iOSVersion = ''): boolean {
        return (iOSVersion.match(/15_0_.\d+/) || []).length > 0;
    }

    public show(currentOrientation: ScreenOrientation): void {
        if (currentOrientation === ScreenOrientation.PORTRAIT) {
            return;
        }

        super.show(currentOrientation);
    }

    public hide(currentOrientation: ScreenOrientation): void {
        if (currentOrientation === ScreenOrientation.PORTRAIT) {
            return;
        }

        super.hide(currentOrientation);
    }
}
